import React, { useRef, useState } from 'react'
import { Box, Button, IconButton, InputAdornment, TextField, Typography } from '@mui/material'
import styles from '../modal.module.css'
import ClearIcon from '@mui/icons-material/Clear';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import * as api from '../../../pages/services/api'
import add from '../../../assets/icons/add.svg'
import Loader from 'components/Loader';
import del from '../../../assets/icons/e-learning/delete_red.svg'

function ModalContactPromoter({ onClose, role }) {

    const [loading, setLoading] = useState(false)
    const [data, setData] = useState({
        topic: '',
        detail: ''
    })
    const [attachment, setAttachment] = useState([
        {
            // fieldname: '',
            // originalname: '',
            // encoding: '',
            // mimetype: '',
            // destination: '',
            // filename: '',
            // path: '',
            // size: '',
            // url: ''
            file_path: '',
            file_source: '',
            file_name: '',
            bucket_name: '',
            original_name: '',
            mime_type: '',
            size: '',
            file_api_url: '',
            file_access_url: ''
        }
    ])
    // const [file, setFile] = useState(null)


    const fileRef = useRef([]);
    const handleButtonClickFile = (index) => {
        fileRef.current[index].click();
    }
    const handleFileChangeFlie = async (e, idx) => {
        const file = e.target.files && e.target.files[0];
        if (!file) return

        let formData = new FormData()
        formData.append('file', file)
        formData.append('file_path', `/contact`)
        formData.append('file_source', 'contact')
        formData.append('file_name', file.name)

        setLoading(true)
        let res = await api.uploadFileImage('contact', formData)
        setLoading(false)
        if (!res) return alert('ไม่ตอบสนอง')

        const code = res['code']
        if (code === 200) {
            let newAttachment = [...attachment];
            newAttachment[idx] = res['data'];
            setAttachment(newAttachment);
        } else if (code === 403) {
            alert('ติดต่อสื่อสาร รองรับไฟล์เฉพาะ .pdf, .docx, .xlsx, .ppt, .pptx, .jpeg, .jpg, .png, .txt เท่านั้น')
        } else {
            console.log('error', res)
            alert('ไม่ตอบสนอง')
        }

        // setLoading(true)
        // let res = await api.uploadFile2(role === 'G-0010' ? 'admin' : 'promotor', formData)
        // setLoading(false)
        // if (res) {
        //     if (res['data']['code'] === 200) {
        //         // console.log(res['data']['data'])
        //         let data = res['data']['data']

        //         let newAttachment = [...attachment];
        //         newAttachment[idx] = data;
        //         setAttachment(newAttachment);
        //     } else {
        //         //alert(res['data']['message'])
        //     }
        // } else {
        //     alert('ไม่ตอบสนอง')
        // }
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setData({ ...data, [name]: value });
    };

    const handClickDeleteAttachment = (index, i) => {
        attachment.splice(index, 1)
        setAttachment([...attachment])
    }

    const handleClickAddFile = () => {
        attachment.push({
            file_path: '',
            file_source: '',
            file_name: '',
            bucket_name: '',
            original_name: '',
            mime_type: '',
            size: '',
            file_api_url: '',
            file_access_url: ''
        })
        setAttachment([...attachment])
    }

    const notification = () => {
        let body = {
            "group_code": role === 'G-0010' ? 'G-17' : 'G-0010',
            "topic": data['topic'],
            "detail": data['detail'],
            "attachment_file": attachment
        }
        // console.log(body)
        contact(body)
    }

    const contact = async (body) => {
        setLoading(true)
        let res = await api.contact(body)
        setLoading(false)
        if (res) {
            if (res['data']['code'] === 200) {
                //alert(res['data']['message'])
                onClose()
            } else {
                //alert(res['data']['message'])
            }
        } else {
            alert('ไม่ตอบสนอง')
        }
    }

    return (
        <>
            <Loader loading={loading} />
            <Box className={styles.backgroundModal}>
                <Box className={styles.boxModal}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Box sx={{ display: 'flex', gridGap: '10px' }}>
                            <Box sx={{ border: '5px solid #478F96' }} />
                            <Box sx={{
                                fontWeight: 600,
                                fontSize: '18px',
                                color: '#478F96',
                                "@media (max-width: 800px)": {
                                    fontSize: '16px',
                                }
                            }}>
                                {role === 'G-17' ?
                                    <>ติดต่อแอดมิน</>
                                    :
                                    <>ติดต่อนักสร้างเสริม</>
                                }
                            </Box>
                        </Box>
                        <Box sx={{ '&:hover': { cursor: 'pointer' } }}>
                            <IconButton onClick={() => { onClose() }}>
                                <ClearIcon />
                            </IconButton>
                        </Box>
                    </Box>

                    <Box sx={{ display: 'grid', gridGap: '10px', margin: '10px 0' }}>
                        <Box sx={{ fontWeight: 600 }}>หัวข้อ</Box>
                        <TextField
                            fullWidth
                            size='small'
                            placeholder='แจ้งนำส่งเอกสาร'
                            value={data['topic']}
                            name={"topic"}
                            onChange={handleChange}
                        />
                        <Box sx={{ fontWeight: 600 }}>รายละเอียด</Box>
                        <TextField
                            fullWidth
                            rows={4}
                            multiline
                            placeholder='แจ้งรายละเอียด'
                            value={data['detail']}
                            name={"detail"}
                            onChange={handleChange}
                        />

                        <Box sx={{ fontWeight: 600, display: 'flex', gridGap: '10px' }}>
                            <Box>แนบไฟล์</Box>
                            <img style={{ width: '20px' }} src={add} onClick={() => { handleClickAddFile() }} />
                        </Box>
                        {attachment.map((i, idx) => (
                            <Box sx={{ display: 'grid', gridTemplateColumns: '11fr 1fr', gridGap: '5px' }}>
                                <Box>
                                    <TextField
                                        fullWidth
                                        size='small'
                                        id='file-upload'
                                        placeholder='แนบไฟล์'
                                        onClick={() => handleButtonClickFile(idx)}
                                        value={i['file_name']}
                                        slotProps={{
                                            input: {
                                                readOnly: true,
                                                startAdornment: <InputAdornment position='start'><AttachFileIcon /></InputAdornment>
                                            }
                                        }}
                                    />
                                    <input
                                        id='file-upload'
                                        type="file"
                                        // ref={fileRef}
                                        accept=".pdf,.docx,.xlsx,.ppt,.pptx,.jpeg,.jpg,.png,.txt"
                                        ref={el => fileRef.current[idx] = el}
                                        onChange={(event) => {
                                            handleFileChangeFlie(event, idx)
                                        }}
                                    />
                                </Box>
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                    <img src={del} style={{ width: '22px' }} onClick={() => { handClickDeleteAttachment(idx) }} />
                                </Box>
                            </Box>
                        ))}

                        <Box sx={{ textAlign: 'center' }}>
                            <Button
                                variant='contained'
                                onClick={() => { notification() }}
                            >ส่ง</Button>
                        </Box>
                    </Box>
                </Box>
            </Box>
        </>
    )
}

export default ModalContactPromoter
